import {StyleSheet} from "aphrodite";
import * as React from "react";

import {Text, View} from "@khanacademy/wonder-blocks-core";
import {mediaQueries} from "@khan/shared-styles";

import ImageLadderRung from "./image-ladder-rung.tsx";

type ImageInfo = {
    title: string;
    description: string;
    imgUrl: string;
    imgAltText: string;
};

type Props = {
    title: string;
    images: Array<ImageInfo>;
};

// TODO(jeff): We should replace this with a Wonder Blocks typography component
// but there currently is not one yet that supports the design and the Title
// component is overriding our changes.
const TitleTextHack = (props: {children: string}) => (
    <Text tag="h1" style={styles.title}>
        {props.children}
    </Text>
);

export default class ImageLadder extends React.Component<Props> {
    render(): React.ReactNode {
        const {title, images} = this.props;
        return (
            <View>
                <TitleTextHack>{title}</TitleTextHack>
                {images.map((img, i) => (
                    <ImageLadderRung
                        key={i}
                        title={img.title}
                        description={img.description}
                        imgUrl={img.imgUrl}
                        imgAltText={img.imgAltText}
                        imgPlacement={i % 2 === 0 ? "left" : "right"}
                    />
                ))}
            </View>
        );
    }
}

const styles = StyleSheet.create({
    title: {
        marginBottom: 30,
        alignSelf: "center",
        fontSize: 48,
        lineHeight: 1.19,
        fontWeight: "bold",

        [mediaQueries.md]: {
            fontSize: 46,
            lineHeight: 1.24,
        },

        [mediaQueries.smOrSmaller]: {
            fontSize: 24,
            lineHeight: 2.38,
        },
    },
});
